import React from 'react'
import { Form } from 'semantic-ui-react'


const situationOptions = [
  { key: 'favorable', text: 'Favorable', value: 'favorable' },
  { key: 'defavorable', text: 'Défavorable', value: 'defavorable' }
]
const periodiciteOptions = [
  { key: 'mensuel', text: 'Mensuel', value: 'mensuel' },
  { key: 'annuel', text: 'Annuel', value: 'annuel' }
]
const primeUniqueOptions = [
  { key: 'oui', text: 'Oui', value: 'oui' },
  { key: 'non', text: 'Non', value: 'non' } 
]
const rendementOptions = [
  { key: '3', text: '3 %', value: 0.03 },
  { key: '4', text: '4 %', value: 0.04 }, 
  { key: '5', text: '5 %', value: 0.05 }, 
  { key: '6', text: '6 %', value: 0.06 }, 
  { key: '8', text: '8 %', value: 0.08 }, 
]

const Saisie = ({ situation, premier_versement, versement_libre, periodicite, prime_unique, cotisation, duree, rendement, handleChange }) => (
    <Form style={{ paddingLeft: '2em' }}>
        <Form.Group widths='equal'>
          <Form.Select fluid 
            label='Situation des marchés financiers' 
            options={situationOptions} 
            value={situation} 
            name="situation"
            onChange={handleChange} />
          <Form.Input fluid 
            label='Date du début de versement programmé'
            value={premier_versement} 
            name="premier_versement"
            onChange={handleChange} />
          <Form.Input fluid 
            label='Durée du contrat (en années)'
            value={duree} 
            name="duree"
            onChange={handleChange} />
          <Form.Select fluid 
              label='Rendement UC' 
              options={rendementOptions} 
              value={rendement} 
              name="rendement"
              onChange={handleChange} />
        </Form.Group>
        <Form.Group widths='equal'>
          <Form.Select fluid 
            label='Prime unique' 
            options={primeUniqueOptions} 
            value={prime_unique} 
            name="prime_unique"
            onChange={handleChange} />
          
            <Form.Select fluid 
              label='Périodicité' 
              options={periodiciteOptions} 
              value={periodicite} 
              name="periodicite"
              disabled={prime_unique === 'oui'}
              onChange={handleChange} />
            <Form.Input fluid 
              label='Cotisation mensuelle'
              value={cotisation} 
              name="cotisation"
              disabled={prime_unique === 'oui'}
              onChange={handleChange} />
            <Form.Input fluid 
                label='Versement libre'
                value={versement_libre} 
                name="versement_libre"
                disabled={prime_unique === 'non'}
                onChange={handleChange} />
        </Form.Group>
    </Form>
)

export default Saisie